import { render } from "./SkinScoreRadarChart.vue?vue&type=template&id=10c2be28&scoped=true"
import script from "./SkinScoreRadarChart.vue?vue&type=script&lang=js"
export * from "./SkinScoreRadarChart.vue?vue&type=script&lang=js"

import "./SkinScoreRadarChart.vue?vue&type=style&index=0&id=10c2be28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c2be28"]])

export default __exports__